<template>
    <v-container fluid>

        <!-- HEADER -->
        <v-row class="content-header">
            <v-col>
                <page-title title="Clientes"
                            :subtitle="$t('show')+' '+clients.length+' de '+totalClients+' clientes'"></page-title>
            </v-col>
            <v-col class="text-right">
                <v-btn tile small color="#eee" class="mr-3" @click="showLevels = !showLevels">
                    {{showLevels ? 'ESCONDER ' : 'MOSTRAR '}}NIVEIS
                    <v-icon class="pl-1" v-if="!showLevels" size="18" color="green">mdi-eye</v-icon>
                    <v-icon class="pl-1" v-if="showLevels" size="18" color="red">mdi-eye-off</v-icon>
                </v-btn>
                <!-- Menu que só fica visível/ativo se showLevels for true -->
                <v-menu
                        v-if="showLevels"
                        v-model="menuSelectBrandsDiscounts"
                        :close-on-content-click="false"
                        offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                                color="info"
                                class="mr-3"
                                tile small
                                v-bind="attrs"
                                v-on="on"
                                @click="menuSelectBrandsDiscounts = !menuSelectBrandsDiscounts"
                        >
                            Níveis de Marca ({{ (selectedBrandsDiscount && selectedBrandsDiscount.length) || 0 }})
                            <v-icon right size="small">mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <v-card min-width="260" class="pa-2">
                        <div class="d-flex align-center justify-space-between px-2 py-1">
                            <v-btn
                                    density="compact"
                                    tile x-small
                                    color="primary"
                                    @click="toggleAllBrands"
                            >
                                {{ allBrandsSelected ? 'Desmarcar Todas' : 'Marcar Todas' }}
                            </v-btn>
                        </div>

                        <v-divider class="my-1"></v-divider>

                        <v-list density="compact" class="pa-0">
                            <v-list-item v-for="brand in availableBrands" :key="brand.id" class="px-1" style="min-height: 32px;    border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                                <v-checkbox
                                        v-model="selectedBrandsDiscount"
                                        :value="brand.id"
                                        dense
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <div class="d-flex align-center ga-2" style="min-width: 200px;justify-content: space-between;">
                                            <span style="font-weight: bold;
                                                    text-transform: uppercase;
                                                    font-size: 12px;">
                                                {{ brand.name }}
                                            </span>
                                            <img :src="require('../../assets/img/' + brand.logo)" :alt="brand.name" height="20" style="max-width: 80px" v-if="brand.logo" />
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>

                <v-btn tile small color="success" class="mr-3" to="/clients/clients/new">NOVO</v-btn>
                <v-btn tile small color="error" @click="clearFilters">{{ $t('clearFilters') }}</v-btn>
            </v-col>
        </v-row>

        <!-- CONTENT -->
        <v-row>
            <v-col>
                <div class="staff_v-card">
                    <v-simple-table class="staff_table">
                        <thead>
                        <tr>
                            <th width="80px">Cliente</th>
                            <th>{{ $t('name') }}</th>
                            <th>Email</th>
                            <th>{{ $t('locality') }}</th>
                            <th width="100px">Código Postal</th>
                            <th width="40px">Zona</th>
                            <th width="60px">País</th>
                            <th width="100px">{{ $t('vatNumber') }}</th>
                            <th width="100px">Telefone</th>
                            <th width="100px">B2B</th>
                            <th width="1px">Form</th>
                            <th width="1px">Vend</th>
                            <th width="1px">Perfil</th>
                            <th width="1px" class="text-center" v-if="$readPermission('clients/client_cosec_guaranty')">
                                Cosec Dinamico
                            </th>
                            <!-- Headers dinâmicos - dos niveis das marcas -->
                            <th
                                    v-for="brand in visibleBrands"
                                    :key="brand.id"
                                    class="text-center px-1"
                                    style="width: 36px; min-width: 36px;"
                            >
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <img
                                                v-bind="attrs" v-on="on"
                                                v-if="brand.logo"
                                                :src="require('../../assets/img/' + brand.logo)"
                                                :alt="brand.name"
                                                :title="brand.name"
                                                height="18"
                                                style="max-width: 100%; object-fit: contain;"
                                        />
                                    </template>
                                    <span style="font-size: 11px; font-weight: bold;color: yellow;text-transform: uppercase">{{ brand.name }}</span>
                                </v-tooltip>
                            </th>
                            <th width="1px"></th>
                        </tr>
                        <tr class="filters_row">
                            <td>
                                <v-text-field
                                        v-model="filters.entity"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.name"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.email"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.locality"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.postalCode"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.zone"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.country"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.vatNumber"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.phone"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-select
                                        v-model="filters.accessB2B"
                                        :items="filtersB2B"
                                        dense
                                        outlined
                                        hide-details
                                        @change="setFilters"
                                        item-text="TEXT"
                                        item-value="VALUE"
                                ></v-select>
                            </td>
                            <td>
                                <v-select
                                        v-model="filters.formacao"
                                        :items="filtersYesOrNo"
                                        dense
                                        outlined
                                        hide-details
                                        @change="setFilters"
                                        item-text="TEXT"
                                        item-value="VALUE"
                                ></v-select>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.salesman"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.profile"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td v-if="$readPermission('clients/client_cosec_guaranty')">
                                <v-select
                                        v-model="filters.cosec"
                                        :items="filtersYesOrNo2"
                                        item-value="VALUE"
                                        item-text="TEXT"
                                        dense
                                        outlined
                                        hide-details
                                        @change="setFilters"
                                ></v-select>
                            </td>
                            <!-- Inputs Dinâmicos dos Filtros de Nível por Marca -->
                            <td
                                    v-for="brand in visibleBrands"
                                    :key="'filter-' + brand.id"
                                    class="px-1"
                                    style="width: 36px;"
                            >
                                <v-text-field
                                        v-model="filters[brand.id.toLowerCase()]"
                                        outlined
                                        dense
                                        hide-details
                                        single-line
                                        class="text-center brands-filter"
                                        @keyup.enter="setFilters"
                                ></v-text-field>
                            </td>
                            <td></td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading">
                            <td :colspan="showLevels ? 14 + selectedBrandsDiscount.length : '14'">
                                <v-progress-linear indeterminate></v-progress-linear>
                            </td>
                        </tr>
                        <tr v-for="client in clients">
                            <td>{{ client.Cliente }}</td>
                            <td>{{ client.Nome }}</td>
                            <td>
                                {{ client.Email }}
                                <template v-if="readPermission('clients/clients_accounting')"
                                          v-for="email in client.emailsAccounting">
                                    <br> <span class="red--text"> {{ email.Email }} </span>
                                </template>
                            </td>
                            <td>{{ client.Fac_Local }}</td>
                            <td>{{ client.Fac_Cp }}</td>
                            <td class="text-center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{ client.Zona }}</span>
                                    </template>
                                    <span>{{ client.NomeZona }}</span>
                                </v-tooltip>
                            </td>
                            <td style="white-space: nowrap">
                                {{ client.Pais }}
                                <flag :iso="client.Pais" v-bind:squared=false></flag>
                            </td>
                            <td>{{ client.NumContrib }}</td>
                            <td>{{ client.Telefone }}</td>
                            <td style="white-space: nowrap">
                                <span v-if="client.B2B === '1'"><i class="fas fa-times fa-fw" style="color: red"></i>1-Fech</span>
                                <span v-if="client.B2B === '2'"><i class="fas fa-check fa-fw" style="color: green"></i>2-Aber</span>
                                <span v-if="client.B2B === '3'"><i class="fas fa-times fa-fw" style="color: orange"></i>3-Susp</span>
                                <span v-if="client.B2B === '4'"><i class="fas fa-times fa-fw" style="color: orange"></i>4-Canc</span>
                            </td>
                            <td class="text-center">
                                <span v-if="client.CDU_FORMACAO === 1">{{ $t('yes') }}</span>
                                <span v-if="client.CDU_FORMACAO === 0">{{ $t('no') }}</span>
                            </td>
                            <td class="text-center">{{ client.Vendedor }}</td>
                            <td class="text-center">{{ client.CDU_PROFILE }}</td>
                            <td class="text-center" v-if="$readPermission('clients/client_cosec_guaranty')">
                                <span v-if="client.cosecDynamic > 0">{{ $t('yes') }}</span>
                                <span v-if="client.cosecDynamic === 0">{{ $t('no') }}</span>
                            </td>
                            <!-- Colunas dinamicas dos Níveis de Desconto das Marcas -->
                            <td
                                    v-for="brand in visibleBrands"
                                    :key="brand.id"
                                    class="text-center font-weight-bold"
                            >
                                {{ client[brand.cduKey] !== undefined && client[brand.cduKey] !== null ? client[brand.cduKey] : 0 }}
                            </td>
                            <td>
                                <v-btn tile small color="primary" :to="'/clients/clients/'+client.Cliente">Editar
                                </v-btn>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="4">
                <v-select
                        v-model="pagination.per_page"
                        :items="filtersPerPage"
                        dense
                        outlined
                        hide-details
                        @change="initialize"
                        item-text="TEXT"
                        item-value="VALUE"
                        style="float: left; width: 100px;"
                ></v-select>
            </v-col>
            <v-col class="text-right">
                <v-pagination
                        v-model="pagination.page"
                        :length="getTotalPages"
                        :total-visible="7"
                        @input="initialize"
                        style="justify-content: flex-end;"
                ></v-pagination>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import i18n from '../../plugins/i18n'

export default {
    data: () => ({
        clients: [],
        totalClients: 0,
        loading: false,
        pagination: {
            per_page: 25,
            page: 1
        },
        filters: {
            entity: '',
            name: '',
            email: '',
            locality: '',
            postalCode: '',
            district: '',
            country: '',
            vatNumber: '',
            phone: '',
            accessB2B: '',
            salesman: '',
            formacao: '',
            profile: '',
            cosec: '',
            fox: '',
            nw: '',
            rf_comp: '',
            easton: '',
            kenda: '',
            santa: '',
            cervelo: '',
            namedsport: '',
            evoc: '',
            reserve: '',
            ridemax: '',
            rideconcept: '',
            quoc: '',
            unior: '',
            motul: '',
            cema: '',
            classified: '',
            ferodo: '',
            tecmousse: '',
            tektro: '',
            trp: '',
            lupine: '',
            zone: ''
        },
        filtersYesOrNo: [
            {TEXT: '-', VALUE: ''},
            {TEXT: 'Sim', VALUE: 100},
            {TEXT: i18n.t('no'), VALUE: 250},
        ],
        filtersYesOrNo2: [
            {TEXT: 'Todos', VALUE: ''},
            {TEXT: i18n.t('no'), VALUE: 0},
            {TEXT: i18n.t('yes'), VALUE: 1},
        ],
        filtersPerPage: [
            {TEXT: '25', VALUE: 25},
            {TEXT: '50', VALUE: 50},
            {TEXT: '100', VALUE: 100},
            {TEXT: '250', VALUE: 250},
            {TEXT: '500', VALUE: 500},
            {TEXT: '750', VALUE: 750}
        ],
        filtersB2B: [
            {TEXT: 'Todos', VALUE: ''},
            {TEXT: i18n.t('closed'), VALUE: '1'},
            {TEXT: i18n.t('opened'), VALUE: '2'},
            {TEXT: i18n.t('suspense'), VALUE: '3'},
            {TEXT: 'Cancelado', VALUE: '4'}
        ],
        showLevels: false,
        availableBrands: [
            { id: 'CEMA', cduKey: 'CDU_CEMA', name: 'Cema', logo: 'CEMA.png' },
            { id: 'CLASSIFIED', cduKey: 'CDU_CLASSIFIED', name: 'Classified', logo: 'CLASSIFIED.png' },
            { id: 'EASTON', cduKey: 'WHEELS', name: 'Easton', logo: 'EASTON.png' },
            { id: 'EVOC', cduKey: 'CDU_EVOC', name: 'Evoc', logo: 'EVOC.png' },
            { id: 'FERODO', cduKey: 'CDU_FERODO', name: 'Ferodo', logo: 'FERODO.png' },
            { id: 'FOX', cduKey: 'CDU_FOX', name: 'Fox', logo: 'FOX.png' },
            { id: 'KENDA', cduKey: 'CDU_KENDA', name: 'Kenda', logo: 'KENDA.png' },
            { id: 'KMC', cduKey: 'CDU_KMC', name: 'KMC', logo: 'KMC.png' },
            { id: 'LUPINE', cduKey: 'CDU_LUPINE', name: 'LUPINE', logo: 'LUPINE.png' },
            { id: 'MOTUL', cduKey: 'CDU_MOTUL', name: 'Motul', logo: 'MOTUL.png' },
            { id: 'NAMEDSPORT', cduKey: 'CDU_NAMEDSPORT', name: 'NamedSport', logo: 'NAMEDSPORT.png' },
            // { id: 'NW', cduKey: 'CDU_NW', name: 'Northwave', logo: 'NW.png' },
            { id: 'QUOC', cduKey: 'CDU_QUOC', name: 'Quoc', logo: 'QUOC.png' },
            { id: 'RESERVE', cduKey: 'CDU_RESERVE', name: 'Reserve', logo: 'RESERVE.png' },
            { id: 'RF_COMP', cduKey: 'COMPONENTS', name: 'Race Face', logo: 'RACEFACE.png' },
            { id: 'RIDECONCEP', cduKey: 'CDU_RIDECONCEP', name: 'Ride Concepts', logo: 'RIDECONCEP.png' },
            { id: 'RIDEMAX', cduKey: 'CDU_RIDEMAX', name: 'Ride Max', logo: 'RIDEMAX.png' },
            { id: 'TECMOUSSE', cduKey: 'CDU_TECMOUSSE', name: 'Tecmousse', logo: 'TECMOUSSE.png' },
            { id: 'TEKTRO', cduKey: 'CDU_TEKTRO', name: 'TEKTRO', logo: 'TEKTRO.png' },
            { id: 'TRP', cduKey: 'CDU_TRP', name: 'TRP', logo: 'TRP.png' },
            { id: 'UNIOR', cduKey: 'CDU_UNIOR', name: 'Unior', logo: 'UNIOR.png' }
        ],
        selectedBrandsDiscount: [],
        menuSelectBrandsDiscounts: false
    }),
    computed: {
        getTotalPages() {
            return Math.ceil(this.totalClients / this.pagination.per_page)
        },
        visibleBrands() {
            if (!this.showLevels) return [];
            const selected = this.selectedBrandsDiscount || [];
            const available = this.availableBrands || [];
            return available.filter(b => selected.indexOf(b.id) !== -1);
        },
        allBrandsSelected() {
            const selectedLength = (this.selectedBrandsDiscount && this.selectedBrandsDiscount.length) || 0;
            const availableLength = (this.availableBrands && this.availableBrands.length) || 0;
            return availableLength > 0 && selectedLength === availableLength;
        }
    },
    created() {
        document.title = 'Clientes';
        this.initialize()
    },
    methods: {
        initialize() {
            this.loading = true;
            this.clients = [];

            let filters = {
                pagination: this.pagination,
                filters: this.filters
            };

            ClientModel.dispatch('getClients', filters)
                    .then(response => {
                        let responseData = response.data;
                        if (responseData.status === 'OK') {
                            this.clients = responseData.clients;
                            this.totalClients = responseData.totalClients;
                        }
                        this.loading = false
                    })
                    .catch(() => {
                        this.loading = false
                    })
        },
        setFilters() {
            this.pagination.page = 1;
            this.initialize();
        },
        clearFilters() {
            this.showLevels = false;
            this.selectedBrandsDiscount = [];
            this.filters = {
                entity: '',
                name: '',
                email: '',
                locality: '',
                postalCode: '',
                district: '',
                country: '',
                vatNumber: '',
                phone: '',
                accessB2B: '',
                salesman: '',
                formacao: '',
                profile: '',
                cosec: '',
                fox: '',
                nw: '',
                rf_comp: '',
                easton: '',
                kenda: '',
                santa: '',
                cervelo: '',
                namedsport: '',
                evoc: '',
                reserve: '',
                ridemax: '',
                rideconcept: '',
                quoc: '',
                unior: '',
                motul: '',
                cema: '',
                classified: '',
                ferodo: '',
                tecmousse: '',
                tektro: '',
                trp: '',
                lupine: '',
                zone: ''
            };
            this.pagination.page = 1;
            this.initialize()
        },
        readPermission(permission) {
            return User.getters.readPermission(permission)
        },
        toggleAllBrands() {
            if (this.allBrandsSelected) {
                this.selectedBrandsDiscount = []
            } else {
                this.selectedBrandsDiscount = this.availableBrands.map(b => b.id)
            }
        },
    }
}
</script>
